import React from 'react';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { OrdemProducao } from '../../types/producao';
import { ordensProducaoService } from '../../services';

const formatItemsSummary = (item: OrdemProducao) => {
  const produtoNames =
    item.itens
      ?.map(
        (child) =>
          child.produto_nome ??
          child.produto_pallet_nome ??
          String(child.produto ?? child.produto_pallet ?? child.id),
      )
      .filter(Boolean) ?? [];
  if (!produtoNames.length) return '—';
  const displayed = produtoNames.slice(0, 2).join(', ');
  return produtoNames.length > 2 ? `${displayed} (+${produtoNames.length - 2})` : displayed;
};

const columns: ResourceColumn<OrdemProducao>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Status', accessor: 'status' },
  { header: 'Emissão', accessor: 'data_emissao' },
  { header: 'Início previsto', accessor: 'data_inicio_prevista' },
  {
    header: 'Produtos',
    render: formatItemsSummary,
  },
  {
    header: 'Itens planejados',
    render: (item) => String(item.itens?.length ?? 0),
  },
];

export const OrdensProducaoListPage: React.FC = () => (
  <ResourceListPage
    title="Ordens de produção"
    description="Ordens emitidas e planejamento."
    columns={columns}
    service={ordensProducaoService}
    createPath="/admin/producao/ordens-producao/novo"
    getEditPath={(item) => `/admin/producao/ordens-producao/${item.id}`}
  />
);
